<template>
  <div class="new-node" @click="emit('click')">
    <span><i class="pi pi-plus"/></span>
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  name: "NewNodeButton",
  emits: ['click'],
  setup(_, {emit}) {
    return {
      emit
    }
  },

})
</script>

<style scoped lang="scss">
@use '@assets/css/vars.scss' as *;

.new-node {
  background-color: $lead-color;
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.5rem;
  color: white;
  box-shadow: rgba(17, 12, 46, 0.35) 0 36px 80px 0;
}
</style>
